import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('KovanHrFileMetadataModel')
export class FileMetadataModel extends HvlBaseModel {
    @JsonProperty('name', String, true)
    name: string = null;

    @JsonProperty('contentType', String, true)
    contentType: string = null;

    @JsonProperty('fileSize', Number, true)
    size: number = null;
}
